import React from 'react';
import type { RedcatIconProps } from './RedcatIcon';
import { REDCAT_ICON_DEFAULT_COLOR, REDCAT_ICON_DEFAULT_SIZE } from './RedcatIcon';

const RedcatMapPinVariantIcon = ({
  size = REDCAT_ICON_DEFAULT_SIZE,
  color = REDCAT_ICON_DEFAULT_COLOR,
}: RedcatIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 13.88C9.65208 12.3867 10.8776 11.03 11.6766 9.81C12.4755 8.59 12.875 7.50667 12.875 6.56C12.875 5.10667 12.4044 3.91667 11.4633 2.99C10.5221 2.06333 9.36771 1.6 8 1.6C6.63229 1.6 5.47786 2.06333 4.53672 2.99C3.59557 3.91667 3.125 5.10667 3.125 6.56C3.125 7.50667 3.52448 8.59 4.32344 9.81C5.1224 11.03 6.34792 12.3867 8 13.88ZM8 16C5.81979 14.1733 4.19141 12.4767 3.11484 10.91C2.03828 9.34333 1.5 7.89333 1.5 6.56C1.5 4.56 2.15339 2.96667 3.46016 1.78C4.76693 0.593333 6.28021 0 8 0C9.71979 0 11.2331 0.593333 12.5398 1.78C13.8466 2.96667 14.5 4.56 14.5 6.56C14.5 7.89333 13.9617 9.34333 12.8852 10.91C11.8086 12.4767 10.1802 14.1733 8 16Z"
        fill={color}
      />
      <circle cx="8" cy="6.5" r="2" fill={color} />
    </svg>
  );
};

export default RedcatMapPinVariantIcon;
